import { NoResultsIllustration } from '@eventbrite/eds-iconography';
import { gettext } from '@eventbrite/i18n';
import { Typography } from '@eventbrite/marmalade';
import React from 'react';

import styles from './NoResultsMessage.module.scss';

const NoResultsMessage: React.FunctionComponent = () => (
    <section className={styles.noResultsSection}>
        <div className={styles.noResultsIllustration}>
            <NoResultsIllustration />
        </div>
        <div className={styles.noResultsMessage}>
            <Typography variant="body-lg" color={'neutral-1000'}>
                {gettext(
                    'Nothing matched your search, but you might like these options',
                )}
            </Typography>
        </div>
    </section>
);

export default NoResultsMessage;
